import styled from "styled-components";

export const Bar = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 12px 16px;
    margin-bottom: 16px;
`;

// Селект меню не должен распирать строку на узком вьюпорте и не должен схлопываться в ноль.
export const MenuField = styled.div`
    flex: 1 1 240px;
    min-width: 0;
    max-width: 320px;
`;

export const Chips = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;
